export default __webpack_public_path__ + "static/media/students-dropdown-arrow.ad7a36a1.svg";